import { useQuery } from '@tanstack/react-query';
import UsersAPIServiceV2 from './UserServiceV2';
import PaymentsAPIServiceV2 from './PaymentsServiceV2';

const usersService = UsersAPIServiceV2.getInstance();
const paymentsService = PaymentsAPIServiceV2.getInstance();

export const USERS_QUERY_KEYS: { [key: string]: string } = {
    getConsents: 'getConsents',
    getCurrentUser: 'getCurrentUser',
    getCurrentCompany: 'getCurrentCompany',
    getUser: 'getUser',
    getBackofficeUser: 'getBackofficeUser',
    getSharedEmailEmployments: 'getSharedEmailEmployments',
    getTermsVersions: 'getTermsVersions',
    getSupportedLanguages: 'getSupportedLanguages',
    getCompanies: 'getCompanies',
    getLoginType: 'getLoginType'
};

export const useGetConsents = (enabled: boolean = true) => {
    return useQuery({
        queryKey: [USERS_QUERY_KEYS.getConsents, enabled],
        queryFn: usersService.getConsents,
        enabled
    });
};

export const useGetCurrentUser = (enabled: boolean = true) => {
    return useQuery({
        queryKey: [USERS_QUERY_KEYS.getCurrentUser, enabled],
        queryFn: usersService.getCurrentUser,
        enabled
    });
};

export const useGetCurrentCompany = (enabled: boolean = true) => {
    return useQuery({
        queryKey: [USERS_QUERY_KEYS.getCurrentCompany, enabled],
        queryFn: usersService.getCurrentCompany,
        enabled
    });
};

export const useGetUser = (userId: string, enabled: boolean = true) => {
    return useQuery({
        queryKey: [USERS_QUERY_KEYS.getUser, userId, enabled],
        queryFn: () => usersService.getUser(userId),
        enabled: enabled && !!userId
    });
};

export const useGetBackofficeUser = (
    userId: string,
    enabled: boolean = true
) => {
    return useQuery({
        queryKey: [USERS_QUERY_KEYS.getBackofficeUser, userId, enabled],
        queryFn: () => paymentsService.getBackofficeUser(userId),
        enabled: enabled && !!userId
    });
};

export const useGetSharedEmailEmployments = (
    userId: string,
    enabled: boolean = true
) => {
    return useQuery({
        queryKey: [USERS_QUERY_KEYS.getSharedEmailEmployments, userId, enabled],
        queryFn: () => usersService.getSharedEmailEmployments(userId),
        enabled: enabled && !!userId
    });
};

export const useGetTermsVersions = (enabled: boolean = true) => {
    return useQuery({
        queryKey: [USERS_QUERY_KEYS.getTermsVersions, enabled],
        queryFn: usersService.getTermsVersions,
        enabled
    });
};

export const useGetSupportedLanguages = (enabled: boolean = true) => {
    return useQuery({
        queryKey: [USERS_QUERY_KEYS.getSupportedLanguages, enabled],
        queryFn: usersService.getSupportedLanguages,
        enabled
    });
};

export const useGetCompanies = (enabled: boolean = true) => {
    return useQuery({
        queryKey: [USERS_QUERY_KEYS.getCompanies, enabled],
        queryFn: usersService.getCompanies,
        enabled
    });
};

export const useGetLoginType = (email: string, enabled: boolean = false) => {
    return useQuery({
        queryKey: [USERS_QUERY_KEYS.getLoginType, email],
        queryFn: () => usersService.getLoginType(email),
        enabled: enabled && !!email,
        retry: false
    });
};
